import type { JSX } from 'react';

import * as Styles from './styles';
import { InfoBorderedProps } from './types';

const InfoBordered = ({
  label,
  title,
  subtitle,
  className,
}: InfoBorderedProps): JSX.Element => {
  return (
    <Styles.Container className={className}>
      {label && <Styles.Label>{label}</Styles.Label>}
      <Styles.InfoContainer>
        {title && <Styles.Title>{title}</Styles.Title>}
        {subtitle && <Styles.SubTitle>{subtitle}</Styles.SubTitle>}
      </Styles.InfoContainer>
    </Styles.Container>
  );
};

export { InfoBordered };
